import { render, staticRenderFns } from "./FormSetDmsVss.vue?vue&type=template&id=61fa2c8e"
import script from "./FormSetDmsVss.vue?vue&type=script&lang=js"
export * from "./FormSetDmsVss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports